<div
  class="pill"
  [class.pill--checked]="selected"
  [class.pill--range]="range"
  [ngClass]="{ 'has-icon': showSelectedIcon, 'always-show-icon': alwaysShowIcon }"
  (click)="clickPill($event)"
  [attr.data-qa]="testId"
>
  <rx-icon
    @headShake
    [name]="icon"
    *ngIf="showSelectedIcon && (selected || alwaysShowIcon)"
    class="pill__icon"
    [fill]="selected ? 'primary-darker' : 'grey-darker'"
  />
  <span class="f-color-regular pill__label" [ngClass]="{ 'ml-2': alwaysShowIcon }">{{ label }}</span>
</div>
